<script lang="ts">
  import { onMount } from 'svelte';

  let visible = $state(false);

  onMount(() => {
    if (!localStorage.getItem('bleunk-consent')) {
      setTimeout(() => (visible = true), 900);
    }
  });

  async function accept() {
    localStorage.setItem('bleunk-consent', 'all');
    visible = false;
    window.dispatchEvent(new Event('bleunk-consent-changed'));

    // Persist consent record for compliance (RA 10173)
    try {
      await fetch('/api/consent', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          analytics: true,
          marketing: true,
          functional: true,
          consentGiven: true
        })
      });
    } catch (err) {
      console.error('[consent] Failed to log consent:', err);
    }
  }

  function decline() {
    localStorage.setItem('bleunk-consent', 'essential');
    visible = false;
  }
</script>

{#if visible}
  <div
    class="fixed bottom-6 right-6 left-6 sm:left-auto z-[90] sm:w-[440px]"
    aria-live="polite"
    aria-label="Cookie consent"
  >
    <div class="bg-card border border-dim-8 rounded-2xl shadow-2xl p-5 flex flex-col gap-4">
      <div class="min-w-0">
        <p class="text-sm text-dim-60 leading-relaxed">
          We use essential cookies to run this site. With your consent we may also use analytics cookies to understand how it is used.
          <a href="/privacy" class="text-[#C9A87C] hover:underline underline-offset-2 ml-1 whitespace-nowrap focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#C9A87C]/50 rounded">
            Privacy Policy →
          </a>
        </p>
      </div>
      <div class="flex items-center gap-3 shrink-0">
        <button
          onclick={decline}
          class="flex-1 px-4 py-2.5 rounded-xl text-xs font-medium text-dim-60 hover:text-content border border-dim-8 hover:border-dim-15 bg-dim-3 hover:bg-dim-5 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#C9A87C]/50 transition-all"
        >
          Essential only
        </button>
        <button
          onclick={accept}
          class="flex-1 px-4 py-2.5 rounded-xl text-xs font-semibold bg-[#C9A87C] hover:bg-[#D4B896] text-[#08080E] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#C9A87C]/50 transition-all shadow-md shadow-[#C9A87C]/15"
        >
          Accept all
        </button>
      </div>
    </div>
  </div>
{/if}
